import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 费用tab-运价表查询
export function queryPriceAirRealDetail(data) {
  return request({
    url: URL.price.queryPriceAirRealDetail,
    method: 'post',
    data
  })
}
// 费用tab-运价表查询
export function queryPriceAirRealSimplePriceNo(data) {
  return request({
    url: URL.price.queryPriceAirRealSimplePriceNo,
    method: 'post',
    data
  })
}

// 运价导出
export function exportByTemplate(data, currency) {
  return request({
    url: URL.price.exportByTemplate,
    method: 'post',
    responseType: 'blob',
    data,
    params: { currency }
  })
}

// 空运运价输入-列表查询
export function queryPriceAirList(data) {
  return request({
    url: URL.price.queryPriceAirList,
    method: 'post',
    data
  })
}
// 空运运价输入-保存
export function savePriceAir(data) {
  return request({
    url: URL.price.savePriceAir,
    method: 'post',
    data
  })
}
// 空运运价输入-删除
export function deletePriceAirs(data) {
  return request({
    url: URL.price.deletePriceAirs,
    method: 'post',
    data
  })
}
// 空运运价输入-审核，同步
export function approvePriceAirsWithAllTiers(data) {
  return request({
    url: URL.price.approvePriceAirsWithAllTiers,
    method: 'post',
    data
  })
}
// 空运运价输入-加价审核
export function markupApprovePriceAirs(data) {
  return request({
    url: URL.price.markupApprovePriceAirs,
    method: 'post',
    data
  })
}

// 空运运价统计，按状态、按时间列表查询
export function getPriceAirStat(data) {
  return request({
    url: URL.price.getPriceAirStat,
    method: 'post',
    data
  })
}

// 根据运价UUID查询
export function queryPriceAirByKey(params) {
  return request({
    url: URL.price.queryPriceAirByKey,
    method: 'get',
    params: params
  })
}

// 按照分值过滤查询空运附加费
export function querySurchargeAirsByScore(data) {
  return request({
    url: URL.price.querySurchargeAirsByScore,
    method: 'post',
    data
  })
}

